import { Box, Button, useTheme, useMediaQuery } from "@mui/material";
import { tokens } from "../../theme";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import Header from "../../components/Header";
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import StatBox from "../../components/StatBox";
import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import ChatBot from "../../hrm/app/views/chat-bot-firestore";
const Dashboard = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isSmallScreen = useMediaQuery("(max-width: 900px)");
  const userEmail = localStorage.getItem('UserEmail') || '';
  const [past90DaysTotal, setPast90DaysTotal] = useState(0);
  const [currentMonthTotal, setCurrentMonthTotal] = useState(0);
  const [EmergencyLeave, setEmergencyLeave] = useState(0);
  const [PlannedLeave, setPlannedLeave] = useState(0);
  const [totalBalanceLeave, setTotalBalanceLeave] = useState(0);
  const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/annualleave?UserEmail=${userEmail}`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      .then(response => response.json())
      .then(data => {
        const [balanceLeave] = data;
        setEmergencyLeave(balanceLeave.emergencyleave);
        setPlannedLeave(balanceLeave.plannedleave);
        setTotalBalanceLeave(balanceLeave.annualleave);
      })
      .catch(error => console.log(error));
  }, [userEmail]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/application/details`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json','Authorization': `Bearer ${accessToken}` },
      body: JSON.stringify({ userEmail })
    })
      .then(response => response.json())
      .then(data => {
        const filteredData = data.filter(item => item.ApplicationStatus === 'APPROVED');
        const currentMonth = new Date().getMonth() + 1;
        const currentYear = new Date().getFullYear();
        const past90Days = new Date();
        past90Days.setDate(past90Days.getDate() - 90);

        let past90DaysData = [];
        let currentMonthData = [];

        filteredData.forEach(item => {
          const itemDate = new Date(item.startingdate);
          if (isNaN(itemDate)) return;
          if (itemDate >= past90Days && itemDate <= new Date()) {
            past90DaysData.push(item);
          }
          if (itemDate.getMonth() + 1 === currentMonth && itemDate.getFullYear() === currentYear) {
            currentMonthData.push(item);
          }
        });

        setPast90DaysTotal(past90DaysData.reduce((total, item) => total + item.noofdays, 0));
        setCurrentMonthTotal(currentMonthData.reduce((total, item) => total + item.noofdays, 0));
      })
      .catch(error => console.log("Error fetching data:", error));
  }, [userEmail]);

  return (
    <Box m="20px">
      {/* <ChatBot/> */}
      {/* HEADER */}
      <Box display="flex" flexDirection={isSmallScreen ? "column" : "row"} justifyContent="space-between" alignItems={isSmallScreen ? "flex-start" : "center"}>
        <Header title="DASHBOARD" subtitle="Welcome to your dashboard" />
        <Button
          sx={{
            backgroundColor: colors.blueAccent[700],
            color: colors.grey[100],
            fontSize: "14px",
            fontWeight: "bold",
            padding: "10px 20px",
            mt: isSmallScreen ? "10px" : 0,
          }}
        >
          <DownloadOutlinedIcon sx={{ mr: "10px" }} />
          Download Reports
        </Button>
      </Box>

      {/* GRID & CHARTS */}
      <Box
        display="grid"
        gridTemplateColumns={isSmallScreen ? "1fr" : "repeat(8, 1fr)"}
        gridAutoRows="150px"
        gap="20px"
      >
        {/* ROW 1 */}
        <Box gridColumn={isSmallScreen ? "span 8" : "span 3"} backgroundColor={colors.primary[400]} display="flex" alignItems="center" justifyContent="center">
          <StatBox
            title={<Link to="/past90days" style={{ textDecoration: "none", color: "inherit" }}>Leaves Taken in Last 90 days</Link>}
            subtitle={past90DaysTotal}
            icon={<EventOutlinedIcon sx={{ color: colors.greenAccent[600], fontSize: "26px" }} />}
          />
        </Box>

        <Box gridColumn={isSmallScreen ? "span 8" : "span 3"} backgroundColor={colors.primary[400]} display="flex" alignItems="center" justifyContent="center">
          <StatBox
            title={<Link to="/currentmonth" style={{ textDecoration: "none", color: "inherit" }}>Leaves taken in Current Month</Link>}
            subtitle={currentMonthTotal}
            icon={<EventOutlinedIcon sx={{ color: colors.greenAccent[600], fontSize: "26px" }} />}
          />
        </Box>

        <Box gridColumn={isSmallScreen ? "span 8" : "span 3"} backgroundColor={colors.primary[400]} display="flex" flexDirection="column" alignItems="center" justifyContent="center">
          <div style={{ alignSelf: "start", paddingTop: "18px", width: "90%" }}>
            <StatBox
              title={<Link to="/transsitionhistory" style={{ textDecoration: "none", color: "inherit" }}>Balance Leaves</Link>}
              subtitle={totalBalanceLeave}
              icon={<EventOutlinedIcon sx={{ color: colors.greenAccent[600], fontSize: "26px" }} />}
            />
          </div>
          <div style={{ alignSelf: "center", paddingTop: "10px" }}>
            <p>EL : {EmergencyLeave} | PL : {PlannedLeave}</p>
          </div>
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard;
